import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const LtiLinkBlockWrapper = styled.div<{ isSelected: boolean }>`
  width: 100%;
  height: 64px;
  border-radius: ${theme.borderRadius.medium};
  border: ${({ isSelected }) =>
    isSelected
      ? `1px solid ${theme.color.designSystem.purple70}`
      : `1px solid ${theme.color.designSystem.grey20}`};
  display: flex;
  align-items: center;
  margin-bottom: ${theme.spacing.small};
  background-color: ${({ isSelected }) =>
    isSelected
      ? theme.color.designSystem.purple30
      : theme.color.designSystem.grey20};
  cursor: pointer;
`;

export const Url = styled.div`
  color: ${theme.color.designSystem.purple70};
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }
`;

export const Title = styled.div`
  font-weight: ${theme.font.weight.bold};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  margin-left: 5px;
`;

export const Description = styled.div`
  margin-bottom: ${theme.spacing.xSmall};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${theme.spacing.xSmall};
`;

export const ContentWrapper = styled.div`
  display: flex;
`;

export const Content = styled.div<{ hasIcon: boolean }>`
  ${({ hasIcon }) => hasIcon && `margin-left: ${theme.spacing.xxLarge};`}
  display: flex; // makes sure link does not create a new line on firefox
  flex-direction: column;
`;

export const LoadingContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  font-size: 14px;
  height: 38px;
  justify-content: center;
  color: ${theme.color.designSystem.blackOpacity87};
  padding: 14px;
  margin-top: ${theme.spacing.small};
  margin-bottom: ${theme.spacing.small};
  margin-right: -${theme.spacing.xxxSmall};
  background-color: ${theme.color.designSystem.grey20};
  border-radius: ${theme.borderRadius.medium};
`;

export const BlockLinkWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const BlockLinkContent = styled.div``;

export const ImageWrapper = styled.span`
  padding-left: 4px;
  width: 27px;
`;
